<template>
  <div class="card" :data-background-color="color">
    <div class="card-header">
      <div
        class=""
        title="Humane World Apps"
        role="img"
        aria-label="Humane World Apps"
        v-bind:style="{
          minWidth: '80px',
          height: '80px',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          backgroundImage: 'url(' + getProjectIcon + ')',
          backgroundSize: 'cover',
          borderRadius: '5px',
        }"
      ></div>
      <div class="">
        <router-link
          v-if="
            userRole != '4' &&
              userRole != '5' &&
              userRole != '6' &&
              userRole != '7' &&
              userRole != '8'
          "
          :to="projectDetails"
          tag="p"
        >
          <p class="project-title">
            {{ title }}
          </p>
        </router-link>
        <a
          style="text-decoration: none; color: black;"
          href="https://play.google.com/store/apps/details?id=in.fusionbit.hsapps"
          target="_blank"
          v-else
          class="project-title"
        >
          {{ title }}
          <br />
          <br />
        </a>

        <p v-if="createdOn && !trashed" class="project-info-text">
          Created On: {{ createdOn }}
        </p>
        <p v-if="trashed" class="project-info-text">
          Trashed At: {{ convertDate(trashed) }}
        </p>
        <p v-if="getUserRole" class="project-info-text">
          Role: {{ getUserRole }}
        </p>
        <p v-if="lastActive" class="project-info-text">
          Last Active: {{ lastActive }}
        </p>
        <p v-if="fieldUsers" class="project-info-text">
          Field Users: {{ fieldUsers }}
        </p>
      </div>
      <div class="project-properties">
        <el-tooltip
          v-if="isOrgProject"
          :content="orgName"
          :open-delay="300"
          placement="right"
        >
          <p class="blue-tag" v-if="isOrgProject">ORG</p>
        </el-tooltip>
      </div>
    </div>

    <hr />
    <div class="project-card-footer">
      <p
        v-if="!trashed && !archive"
        class="project-contributors"
        style="margin-top: 5px;"
      >
        Animals Treated: {{ animalsTreated }}
      </p>
      <p v-if="daysLeftForDelete && trashed" class="project-contributors" style="color: red;">
        Permanent Deletion In: {{ daysLeftForDelete }} Day<span v-if="daysLeftForDelete > 1">s</span>
      </p>

      <el-tooltip
        v-if="!trashed && !archive"
        content="Action"
        :open-delay="300"
        placement="right"
      >
        <el-dropdown
          class="float-right"
          trigger="click"
          @command="onAction($event, isArchived)"
        >
          <span class="el-dropdown-link action-menu-trigger">
            <i class="el-icon-more-outline"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="archive" class="dropdown-item-icon">
              <i class="fa fa-archive fa-1x"></i>
              <span>Archive</span>
            </el-dropdown-item>

            <el-dropdown-item command="trash" class="dropdown-item-icon">
              <i class="fa fa-trash fa-1x"></i>
              <span>Move to Trash</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-tooltip>

      <div v-else>
        <el-tooltip :content="trashed ? 'Put Back' : 'Restore'" :open-delay="300" placement="right">
          <p class="float-right cursor-pointer" @click="onAction(trashed ? 'trash' : 'archive')">
            <i
              class="fa fa-rotate-left fa-1x"
              style="font-size: large; color: grey;"
            ></i>
          </p>
        </el-tooltip>
      </div>

    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";

import { Dropdown, DropdownItem, DropdownMenu, Tooltip } from "element-ui";
import dpmlogo from "../../../../assets/images/pm-logo.png";
import mvdlogo from "../../../../assets/images/mv-logo.png";

import mvLogo from "../../../../assets/images/mv_logo.png";
import pmLogo from "../../../../assets/images/pm_logo.png";
import hcLogo from "../../../../assets/images/hc_logo_med.png";

export default {
  components: {
    [Tooltip.name]: Tooltip,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Dropdown.name]: Dropdown,
  },
  name: "card",
  props: {
    projectId: {
      type: Number,
    },
    animalsTreated: {
      type: Number,
    },
    fieldUsers: {
      type: Number,
    },
    title: {
      type: String,
      description: "Card title",
      default: "Project Title",
    },
    createdOn: {
      type: String,
      default: "N/A",
    },
    userRole: {
      default: "",
    },
    lastActive: {
      type: String,
      default: "N/A",
    },
    contributors: {
      type: String,
      default: "0",
    },
    viewers: {
      type: String,
      default: "0",
    },
    color: {
      type: String,
      description: 'Card color (orange|yellow|red|green|blue|"")',
    },
    isOrgProject: {
      type: Boolean,
      default: false,
    },
    orgName: {
      type: String,
    },
    projectImage: {
      type: String,
    },
    projectType: {
      type: String,
    },
    dpmlogo: {
      type: String,
      default: dpmlogo,
    },
    mvdlogo: {
      type: String,
      default: mvdlogo,
    },
    archive: {
      type: Boolean,
      default: false,
    },
    trashed: {
      type: Boolean,
      default: false,
    },
    daysLeftForDelete: {
      type: Number,
      default: null,
    },
  },
  methods: {
    onArchiveProject(isArchived) {
      let vm = this;
      new Swal({
        title: `${isArchived ? "Unarchive" : "Archive"} project ${vm.title}?`,
        type: "warning",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-danger btn-fill",
        cancelButtonClass: "btn btn-success btn-fill",
        confirmButtonText: `${isArchived ? "Unarchive" : "Archive"}`,
        buttonsStyling: false,
      }).then(function(result) {
        if (result.value) {
          const apiRoute =
            `/project/${isArchived ? "unarchive" : "archive"}/` + vm.projectId;
          const loading = vm.$loading({
            lock: true,
            text: `Please wait ${isArchived ? "unarchiving" : "archiving"} ${
              vm.title
            }...`,
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          axios
            .post(apiRoute)
            .then((response) => {
              loading.close();
              if (response.data.response.error.error_code == 0) {
                vm.$emit("get-projects");
                vm.showAlert(response.data.response.error.msg, "", true);
              } else {
                vm.showAlert(response.data.response.error.error_msg, "", false);
              }
            })
            .catch((error) => {
              loading.close();
              if (error.response.data.response.error) {
                vm.showAlert(response.data.response.error.error_msg, "", false);
              }
            });
        }
      });
    },
    onAction(cmd) {
      if (cmd === "archive") {
        this.onArchiveProject(this.archive);
      }
      if (cmd === "trash") {
        this.onTrashProject(this.trashed);
      }
    },
    onTrashProject(isTrashed) {
      let vm = this;
      new Swal({
        title: isTrashed
          ? `Put back project "${vm.title}"?`
          : `Move project "${vm.title}" to Trash?`,
        type: "warning",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-danger btn-fill",
        cancelButtonClass: "btn btn-success btn-fill",
        confirmButtonText: `${isTrashed ? "Put Back" : "Move to Trash"}`,
        buttonsStyling: false,
      }).then(function(result) {
        if (result.value) {
          const apiRoute =
            `/project/${isTrashed ? "untrash" : "trash"}/` + vm.projectId;
          const loading = vm.$loading({
            lock: true,
            text: isTrashed
              ? `Restoring project "${vm.title}"...`
              : `Moving project "${vm.title}" to Trash...`,
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          axios
            .post(apiRoute)
            .then((response) => {
              loading.close();
              if (response.data.response.error.error_code == 0) {
                vm.$emit("get-projects");
                vm.showAlert(response.data.response.error.msg, "", true);
              } else {
                vm.showAlert(response.data.response.error.error_msg, "", false);
              }
            })
            .catch((error) => {
              loading.close();
              if (error.response.data.response.error) {
                vm.showAlert(response.data.response.error.error_msg, "", false);
              }
            });
        }
      });
    },
  },
  computed: {
    getUserRole: function() {
      if (this.$props.userRole != "Owner") {
        let rolesString = "";
        // for (let i = 0; i < this.$props.userRole.length; i++) {
        //     rolesString = rolesString + this.$props.userRole[i].role_name + ' | ';
        // }
        //return rolesString.substring(0, rolesString.length - 2);

        if (this.$props.userRole == 1) {
          rolesString = "Manager";
        }

        if (this.$props.userRole == 2) {
          rolesString = "Contributor";
        }

        if (this.$props.userRole == 3) {
          rolesString = "Viewer";
        }

        if (this.$props.userRole == 4) {
          rolesString = "Surveyor";
        }

        if (this.$props.userRole == 5) {
          rolesString = "Vaccination";
        }

        if (this.$props.userRole == 6) {
          rolesString = "Clinic";
        }

        if (this.$props.userRole == 7) {
          rolesString = "Catch-Release";
        }

        if (this.$props.userRole == 8) {
          rolesString = "Driver";
        }

        return rolesString;
      }
      return this.$props.userRole;
    },
    projectDetails: function() {
      if (this.$props.projectType == "MV") {
        return "/project/mv/" + this.projectId + "/overview";
      } else if (this.$props.projectType == "PM") {
        return "/project/pm/" + this.projectId + "/overview";
      } else if (this.$props.projectType == "HC") {
        return "/project/hc/" + this.projectId + "/overview";
      }
    },
    getProjectIcon: function() {
      if (this.$props.projectImage == null) {
        if (this.$props.projectType == "MV") {
          return mvLogo;
        } else if (this.$props.projectType == "PM") {
          return pmLogo;
        } else if (this.$props.projectType == "HC") {
          return hcLogo;
        } else {
          return "https://vuejs.org/images/logo.png";
        }
      } else if (this.$props.projectImage == "") {
        if (this.$props.projectType == "MV") {
          return mvLogo;
        } else if (this.$props.projectType == "PM") {
          return pmLogo;
        } else if (this.$props.projectType == "HC") {
          return hcLogo;
        } else {
          return "https://vuejs.org/images/logo.png";
        }
      } else {
        if (this.$props.projectImage.includes("mv_logo.png")) {
          return mvLogo;
        } else if (this.$props.projectImage.includes("pm_logo.png")) {
          return pmLogo;
        } else if (this.$props.projectImage.includes("hc_logo_med.png")) {
          return hcLogo;
        } else {
          return this.$props.projectImage;
        }
      }
    },
    tooltipText() {
      return this.archive ? "Unarchive" : "Archive";
    },
  },
};
</script>

<style scoped>
p {
  cursor: default;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo_img {
  height: 30px;
  border-radius: 0px !important;
}

.project-img {
  margin-right: 15px;
}

.project-details {
  margin-bottom: 15px;
}

.project-title {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 200px;
  cursor: pointer;
}

.project-info-text {
  margin: 0;
}

.project-contributors {
  float: left;
}

.project-viewers {
  float: right;
}

.project-card-footer {
  margin-left: 15px;
  margin-right: 15px;
}

.project-properties {
  align-self: end;
}

/* Pradeep Start */
@media only screen and (max-width: 320px) {
  .project-properties {
    /* css add for responsive image MVD and DPM  */
    margin-left: -15px;
  }
}

/* Pradeep End */

.dropdown-item-icon {
  display: flex !important;
  gap: 8px;
}

.dropdown-item-icon i {
  font-size: 16px;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
